<div class="preview-container">
    <div class="preview" [ngClass]="{ 'no-attachment': context.room || context.comments, 'double-attachments-row': document?.attachments?.length > 3 }">
        @if (!!context.safeFileUrl && context.isImageFile === false) {
            @if (context.displayPreview === true) {
                <iframe [src]="context.safeFileUrl" class="preview-iframe"></iframe>
            }
        }
        @if (!!context.textFileContent && context.isImageFile === false) {
            @if (document.type === DocumentType.Sms) {
                <app-sms-viewer
                    [smsDocument]="document"
                    [content]="context.textFileContent"
                    [displayPreview]="context.displayPreview"
                    style="height: 100%; display: block"></app-sms-viewer>
            } @else {
                <app-email-viewer
                    [emailDocument]="document"
                    [emailBody]="context.textFileContent"
                    [displayPreview]="context.displayPreview"
                    style="height: 100%; display: block"></app-email-viewer>
            }
        }
        @if (!!context.safeFileUrl && context.isImageFile === true) {
            <app-image-viewer [safeFileUrl]="context.safeFileUrl" (downloadRequested)="onAttachmentDownloadRequested()" style="height: 100%"></app-image-viewer>
        }
        @if (!!context.room) {
            <div class="room-viewer">
                <app-tchat-room-messages [isLiveTchat]="false" [sourceUser]="context.room.messages[0].sourceUser" [room]="context.room"></app-tchat-room-messages>
            </div>
        }
        @if (!!context.commentType) {
            <div class="comment-viewer">
                <app-comment-viewer
                    [comments]="context.comments"
                    [commentType]="context.commentType"
                    [readonly]="readonly"
                    (commentEdited)="onEditComment($event)"
                    (commentDeleted)="onDeleteComment($event)"></app-comment-viewer>
            </div>
        }
        @if (context.displayPreview === false && !context.room && !context.comments) {
            <span class="preview-p">Prévisualisation du document indisponible. Le format n'est pas pris en charge par le visualisateur.</span>
            @if (defaultSelection) {
                <span class="preview-p">Veuillez cliquer sur le fichier pour le télécharger.</span>
            } @else {
                <span class="preview-p">Le document va être téléchargé par votre navigateur.</span>
            }
        }
        <ngx-spinner name="viewer-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
    </div>
    @if (document && !context.room && !context.commentType && !(document.type === DocumentType.Sms) && loading === false) {
        <div class="attachments">
            @for (attachment of document.attachments; track attachment.id) {
                <app-attachment
                    [readonly]="readonly"
                    [attachment]="attachment"
                    [selected]="selectedAttachment === attachment"
                    (attachmentSelected)="onAttachmentSelected(attachment)"
                    (favoriteStateChanged)="onFavoriteStateChanged(attachment)"></app-attachment>
            }
        </div>
    }
</div>
